import Config from "../config.js";
import { createRequestOptions } from "./utils";
import { get } from "lodash";

export default () => {
  return Object.freeze({
    getPatientActivityReport: async (appId, startDate, endDate) => {
      const options = createRequestOptions({ appId, startDate, endDate });
      const result = await fetch(
        Config.serverUrl + "/GetPatientActivityReport",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getChannelOverviewReport: async (orgId, startDate, endDate) => {
      const options = createRequestOptions({ orgId, startDate, endDate });
      const result = await fetch(
        Config.serverUrl + "/ReportChannelOverview",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getPatientActivityLogForApp: async (appId, startDate, endDate, userId) => {
      const options = createRequestOptions({
        appId,
        startDate,
        endDate,
        userId,
      });
      const result = await fetch(
        Config.serverUrl + "/ReportChannelActivityLog",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
  });
};



// WEBPACK FOOTER //
// ./src/services/reporting.js